export default __webpack_public_path__ + "static/media/dole-juice-module-hero-mobile.09e60ff2.png";